(function () {
  if (window.__blogCallModalReady) return;
  window.__blogCallModalReady = true;

  var COUNTRY_CODES = [
    { code: '+49', country: 'DE', flagBackground: 'linear-gradient(to bottom, #000000 0 33%, #dd0000 33% 66%, #ffce00 66% 100%)' },
    { code: '+380', country: 'UA', flagBackground: 'linear-gradient(to bottom, #005bbb 0 50%, #ffd500 50% 100%)' },
    { code: '+43', country: 'AT', flagBackground: 'linear-gradient(to bottom, #ed2939 0 33%, #ffffff 33% 66%, #ed2939 66% 100%)' },
    { code: '+41', country: 'CH', flagBackground: '#d52b1e' },
    { code: '+420', country: 'CZ', flagBackground: 'linear-gradient(to bottom, #ffffff 0 50%, #d7141a 50% 100%)' },
    { code: '+421', country: 'SK', flagBackground: 'linear-gradient(to bottom, #ffffff 0 33%, #0b4ea2 33% 66%, #ee1c25 66% 100%)' },
    { code: '+31', country: 'NL', flagBackground: 'linear-gradient(to bottom, #ae1c28 0 33%, #ffffff 33% 66%, #21468b 66% 100%)' },
    { code: '+33', country: 'FR', flagBackground: 'linear-gradient(to right, #0055a4 0 33%, #ffffff 33% 66%, #ef4135 66% 100%)' },
    { code: '+39', country: 'IT', flagBackground: 'linear-gradient(to right, #009246 0 33%, #ffffff 33% 66%, #ce2b37 66% 100%)' },
    { code: '+34', country: 'ES', flagBackground: 'linear-gradient(to bottom, #aa151b 0 25%, #f1bf00 25% 75%, #aa151b 75% 100%)' },
    { code: '+48', country: 'PL', flagBackground: 'linear-gradient(to bottom, #ffffff 0 50%, #dc143c 50% 100%)' },
    { code: '+44', country: 'GB', flagBackground: '#012169' },
    { code: '+1', country: 'US', flagBackground: 'linear-gradient(to bottom, #b22234 0 14%, #ffffff 14% 28%, #b22234 28% 42%, #ffffff 42% 56%, #b22234 56% 70%, #ffffff 70% 84%, #b22234 84% 100%)' }
  ];

  var COUNTRY_CODES_BY_LENGTH = COUNTRY_CODES.slice().sort(function (a, b) {
    return b.code.length - a.code.length;
  });

  var DEFAULT_COUNTRY = COUNTRY_CODES.find(function (item) {
    return item.code === '+49';
  }) || COUNTRY_CODES[0];

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function toISODate(date) {
    return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
  }

  function formatDate(date) {
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  }

  function monthLabel(date) {
    return date.toLocaleDateString('en-US', {
      month: 'long',
      year: 'numeric'
    });
  }

  function getMondayIndex(day) {
    return day === 0 ? 6 : day - 1;
  }

  function normalizePhoneCandidate(value) {
    return String(value || '')
      .trim()
      .replace(/^00/, '+')
      .replace(/[()\-.\s]/g, '');
  }

  function onlyDigits(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function findCountryByCode(code, countryCode) {
    return COUNTRY_CODES.find(function (item) {
      return item.code === code || item.country === countryCode;
    }) || DEFAULT_COUNTRY;
  }

  function findCountryByPhone(value) {
    var raw = String(value || '').trim();
    var normalized = normalizePhoneCandidate(raw);

    if (!normalized) {
      return DEFAULT_COUNTRY;
    }

    if (normalized.charAt(0) !== '+') {
      normalized = '+' + normalized;
    }

    return COUNTRY_CODES_BY_LENGTH.find(function (item) {
      return normalized.indexOf(item.code) === 0;
    }) || DEFAULT_COUNTRY;
  }

  function setPhoneCountry(dialog, country) {
    var flagEl = dialog.querySelector('[data-blog-call-phone-flag]');
    var countryCodeEl = dialog.querySelector('[data-blog-call-phone-country-code]');
    var prefixEl = dialog.querySelector('[data-blog-call-phone-prefix]');
    var countryInput = dialog.querySelector('[data-blog-call-phone-country-input]');
    var codeInput = dialog.querySelector('[data-blog-call-phone-code-input]');
    var selectEl = dialog.querySelector('[data-blog-call-phone-select]');

    if (flagEl) {
      flagEl.textContent = '';
      flagEl.setAttribute('aria-label', country.country);
      flagEl.style.background = country.flagBackground || 'var(--ui-color-surface-secondary, #f3f3f3)';
      flagEl.dataset.country = country.country;
    }

    if (countryCodeEl) countryCodeEl.textContent = country.country;
    if (prefixEl) prefixEl.textContent = country.code;
    if (countryInput) countryInput.value = country.country;
    if (codeInput) codeInput.value = country.code;

    if (selectEl) {
      selectEl.value = country.code + '|' + country.country;
    }
  }

  function stripAnyKnownCountryCode(value) {
    var raw = String(value || '').trim();
    var compact = normalizePhoneCandidate(raw);

    if (!compact) return '';

    var normalizedWithPlus = compact.charAt(0) === '+' ? compact : '+' + compact;
    var matchedCountry = COUNTRY_CODES_BY_LENGTH.find(function (item) {
      return normalizedWithPlus.indexOf(item.code) === 0;
    });

    if (matchedCountry) {
      return normalizedWithPlus.slice(matchedCountry.code.length).replace(/^0+/, '');
    }

    return raw;
  }

  function cleanLocalPhoneNumber(value, country) {
    var raw = String(value || '').trim();
    var compact = normalizePhoneCandidate(raw);

    if (!compact) return '';

    var normalizedWithPlus = compact.charAt(0) === '+' ? compact : '+' + compact;

    if (normalizedWithPlus.indexOf(country.code) === 0) {
      return normalizedWithPlus.slice(country.code.length).replace(/^0+/, '');
    }

    return raw;
  }

  function initPhoneCountry(dialog) {
    var phoneInput = dialog.querySelector('[data-blog-call-phone-input]');
    var selectEl = dialog.querySelector('[data-blog-call-phone-select]');
    if (!phoneInput) return;

    var currentCountry = DEFAULT_COUNTRY;

    function updateCountry(country, options) {
      var shouldClean = !options || options.clean !== false;
      currentCountry = country || DEFAULT_COUNTRY;
      setPhoneCountry(dialog, currentCountry);

      if (shouldClean && phoneInput.value) {
        var cleanedPhone = cleanLocalPhoneNumber(phoneInput.value, currentCountry);

        if (cleanedPhone !== phoneInput.value.trim()) {
          phoneInput.value = cleanedPhone;
        }
      }
    }

    function syncCountryFromValue() {
      var value = phoneInput.value;
      var raw = String(value || '').trim();

      if (!raw) return;

      var detectedCountry = findCountryByPhone(raw);
      var normalized = normalizePhoneCandidate(raw);
      var shouldSwitch = false;

      if (raw.indexOf('+') === 0 || raw.indexOf('00') === 0) {
        shouldSwitch = true;
      } else {
        var digits = onlyDigits(raw);
        var detectedDigits = onlyDigits(detectedCountry.code);
        shouldSwitch = detectedDigits && digits.indexOf(detectedDigits) === 0 && digits.length > detectedDigits.length + 2;
      }

      if (shouldSwitch) {
        updateCountry(detectedCountry, { clean: true });
      }
    }

    if (selectEl) {
      selectEl.addEventListener('change', function () {
        var parts = String(selectEl.value || '').split('|');
        var selectedCountry = findCountryByCode(parts[0], parts[1]);
        phoneInput.value = stripAnyKnownCountryCode(phoneInput.value);
        updateCountry(selectedCountry, { clean: true });
        phoneInput.focus();
      });
    }

    updateCountry(DEFAULT_COUNTRY, { clean: false });

    phoneInput.addEventListener('input', syncCountryFromValue);
    phoneInput.addEventListener('keyup', syncCountryFromValue);
    phoneInput.addEventListener('change', syncCountryFromValue);
    phoneInput.addEventListener('blur', syncCountryFromValue);
    phoneInput.addEventListener('paste', function () {
      window.setTimeout(syncCountryFromValue, 0);
    });
  }

  function ensureRecipientEmailPrefilled(dialog) {
    var emailInput = dialog.querySelector('[data-blog-call-email-input]');
    var recipient = (dialog.getAttribute('data-recipient-email') || '').trim();

    if (emailInput && recipient && !emailInput.value.trim()) {
      emailInput.value = recipient;
    }
  }

  function buildMailto(dialog, form) {
    var recipient = (dialog.getAttribute('data-recipient-email') || '').trim();
    var articleTitle = dialog.getAttribute('data-article-title') || document.title || '';
    var data = new FormData(form);
    var firstName = String(data.get('first_name') || '').trim();
    var lastName = String(data.get('last_name') || '').trim();
    var email = String(data.get('email') || '').trim();
    var phoneCountry = String(data.get('phone_country') || '').trim();
    var phoneCode = String(data.get('phone_code') || '').trim();
    var phoneNumber = String(data.get('phone') || '').trim();
    var selectedDate = String(data.get('selected_date') || '').trim();
    var selectedTime = String(data.get('selected_time') || '').trim();

    var countryForPhone = COUNTRY_CODES.find(function (item) {
      return item.code === phoneCode;
    }) || DEFAULT_COUNTRY;
    var cleanPhone = cleanLocalPhoneNumber(phoneNumber, countryForPhone);
    var fullPhone = cleanPhone;

    if (cleanPhone && cleanPhone.charAt(0) !== '+') {
      fullPhone = (phoneCode + ' ' + cleanPhone).trim();
    }

    var subject = 'Book a Call - ' + articleTitle;
    var body = [
      'Hi,',
      '',
      'I would like to book a call.',
      '',
      'First name: ' + firstName,
      'Last name: ' + lastName,
      'Email: ' + email,
      'Phone country: ' + phoneCountry,
      'Phone number: ' + fullPhone,
      'Preferred date: ' + selectedDate,
      'Preferred time: ' + selectedTime,
      '',
      'Article: ' + articleTitle,
      'Page URL: ' + window.location.href
    ].join('\n');

    return 'mailto:' + encodeURIComponent(recipient) + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
  }

  function openMailto(dialog, mailto) {
    if (!mailto) return;

    var link = document.createElement('a');
    link.href = mailto;
    link.style.display = 'none';
    link.setAttribute('rel', 'nofollow');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  function closeDialog(dialog) {
    if (!dialog) return;

    if (dialog.open && typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  }

  function openDialog(dialog) {
    if (!dialog || dialog.open) return;

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', 'open');
    }
  }

  function resetDialogScroll(dialog) {
    var panel = dialog ? dialog.querySelector('.blog-call-modal__panel') : null;

    if (panel) {
      panel.scrollTop = 0;
    }
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function syncDateTimeInputs(dialog) {
    var dateInput = dialog.querySelector('[data-blog-call-date-input]');
    var activeDay = dialog.querySelector('[data-blog-call-date].is-active');
    var timeInput = dialog.querySelector('[data-blog-call-time-input]');
    var activeTime = dialog.querySelector('[data-blog-call-time].is-active');

    if (dateInput && activeDay) {
      var isoDate = activeDay.getAttribute('data-blog-call-date') || '';
      dateInput.value = activeDay.getAttribute('aria-label') || isoDate;
      if (isoDate) dateInput.setAttribute('data-blog-call-date-iso', isoDate);
    }

    if (timeInput && activeTime) {
      timeInput.value = activeTime.getAttribute('data-blog-call-time') || activeTime.textContent.trim();
    }
  }

  function showForm(dialog) {
    var formView = dialog.querySelector('[data-blog-call-form-view]');
    var successView = dialog.querySelector('[data-blog-call-success-view]');
    var form = dialog.querySelector('[data-blog-call-form]');

    dialog.classList.remove('is-success');

    if (formView) {
      formView.hidden = false;
      formView.style.display = '';
    }

    if (successView) {
      successView.hidden = true;
      successView.style.display = 'none';
    }

    if (form) form.reset();
    setPhoneCountry(dialog, DEFAULT_COUNTRY);
    syncDateTimeInputs(dialog);
    resetDialogScroll(dialog);
  }

  function parseCallTime(value) {
    var text = String(value || '').trim().toLowerCase();
    var match = text.match(/^(\d{1,2})(?::(\d{2}))?\s*(am|pm)?$/);

    if (!match) {
      return { hours: 10, minutes: 0 };
    }

    var hours = parseInt(match[1], 10);
    var minutes = parseInt(match[2] || '0', 10);
    var meridiem = match[3] || '';

    if (meridiem === 'pm' && hours < 12) hours += 12;
    if (meridiem === 'am' && hours === 12) hours = 0;

    return { hours: hours, minutes: minutes };
  }

  function compactCalendarDate(date) {
    return date.getFullYear() +
      pad(date.getMonth() + 1) +
      pad(date.getDate()) +
      'T' +
      pad(date.getHours()) +
      pad(date.getMinutes()) +
      '00';
  }

  function buildCalendarUrl(dialog, form) {
    var dateInput = dialog.querySelector('[data-blog-call-date-input]');
    var isoDate = dateInput ? dateInput.getAttribute('data-blog-call-date-iso') : '';
    var data = new FormData(form);
    var selectedTime = String(data.get('selected_time') || '10:00 am').trim();
    var title = 'Call appointment with Aerofoils';
    var articleTitle = dialog.getAttribute('data-article-title') || document.title || '';

    if (!isoDate || isoDate.indexOf('-') === -1) {
      var fallback = new Date();
      fallback.setDate(fallback.getDate() + 1);
      isoDate = toISODate(fallback);
    }

    var parts = isoDate.split('-').map(Number);
    var timeParts = parseCallTime(selectedTime);
    var start = new Date(parts[0], parts[1] - 1, parts[2], timeParts.hours, timeParts.minutes, 0, 0);
    var end = new Date(start.getTime() + 30 * 60 * 1000);
    var details = 'Call appointment requested from: ' + window.location.href;

    if (articleTitle) {
      details = 'Article: ' + articleTitle + '\n' + details;
    }

    return 'https://calendar.google.com/calendar/render?action=TEMPLATE' +
      '&text=' + encodeURIComponent(title) +
      '&dates=' + encodeURIComponent(compactCalendarDate(start) + '/' + compactCalendarDate(end)) +
      '&details=' + encodeURIComponent(details);
  }

  function showSuccess(dialog, form) {
    var formView = dialog.querySelector('[data-blog-call-form-view]');
    var successView = dialog.querySelector('[data-blog-call-success-view]');
    var data = new FormData(form);
    var firstName = String(data.get('first_name') || '').trim() || 'Name';
    var selectedDate = String(data.get('selected_date') || '').trim();
    var selectedTime = String(data.get('selected_time') || '').trim() || '10:00 am';
    var successText = dialog.querySelector('[data-blog-call-success-text]');
    var successDate = dialog.querySelector('[data-blog-call-success-date]');
    var successTime = dialog.querySelector('[data-blog-call-success-time]');
    var calendarLink = dialog.querySelector('[data-blog-call-add-calendar]');
    var template = successText ? successText.getAttribute('data-blog-call-success-template') : '';

    dialog.classList.add('is-success');

    if (formView) {
      formView.hidden = true;
      formView.style.display = 'none';
    }

    if (successView) {
      successView.hidden = false;
      successView.style.display = '';
    }

    if (successText) {
      template = template || 'Thanks, [name]! We’ve reserved your Call appointment.';
      successText.innerHTML = escapeHtml(template).replace(/\[name\]/g, '<strong>' + escapeHtml(firstName) + '</strong>');
    }

    if (successDate) successDate.textContent = selectedDate || 'October 25–26, 2025';
    if (successTime) successTime.textContent = selectedTime;
    if (calendarLink) calendarLink.href = buildCalendarUrl(dialog, form);

    resetDialogScroll(dialog);
  }

  function initCalendar(dialog) {
    var monthLabelEl = dialog.querySelector('[data-blog-call-month-label]');
    var daysEl = dialog.querySelector('[data-blog-call-days]');
    var prevBtn = dialog.querySelector('[data-blog-call-prev-month]');
    var nextBtn = dialog.querySelector('[data-blog-call-next-month]');
    var dateInput = dialog.querySelector('[data-blog-call-date-input]');
    if (!monthLabelEl || !daysEl || !dateInput) return;

    var today = new Date();
    today.setHours(0, 0, 0, 0);

    var selectedDate = new Date(today);
    selectedDate.setDate(selectedDate.getDate() + 1);

    var visibleMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);

    function selectDate(date) {
      selectedDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      dateInput.value = formatDate(selectedDate);
      dateInput.setAttribute('data-blog-call-date-iso', toISODate(selectedDate));
      render();
    }

    function render() {
      monthLabelEl.textContent = monthLabel(visibleMonth);
      daysEl.innerHTML = '';

      var firstDay = new Date(visibleMonth.getFullYear(), visibleMonth.getMonth(), 1);
      var daysInMonth = new Date(visibleMonth.getFullYear(), visibleMonth.getMonth() + 1, 0).getDate();
      var offset = getMondayIndex(firstDay.getDay());

      for (var i = 0; i < offset; i += 1) {
        var empty = document.createElement('span');
        empty.className = 'blog-call-modal__day blog-call-modal__day--empty';
        daysEl.appendChild(empty);
      }

      for (var day = 1; day <= daysInMonth; day += 1) {
        var date = new Date(visibleMonth.getFullYear(), visibleMonth.getMonth(), day);
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'blog-call-modal__day';
        button.textContent = day;
        button.setAttribute('aria-label', formatDate(date));
        button.dataset.blogCallDate = toISODate(date);

        if (date < today) {
          button.disabled = true;
        }

        if (toISODate(date) === toISODate(selectedDate)) {
          button.classList.add('is-active');
          button.setAttribute('aria-pressed', 'true');
        } else {
          button.setAttribute('aria-pressed', 'false');
        }

        button.addEventListener('click', function (event) {
          var value = event.currentTarget.dataset.blogCallDate;
          if (!value) return;

          var parts = value.split('-').map(Number);
          selectDate(new Date(parts[0], parts[1] - 1, parts[2]));
        });

        daysEl.appendChild(button);
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        visibleMonth = new Date(visibleMonth.getFullYear(), visibleMonth.getMonth() - 1, 1);
        render();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        visibleMonth = new Date(visibleMonth.getFullYear(), visibleMonth.getMonth() + 1, 1);
        render();
      });
    }

    selectDate(selectedDate);
  }

  function initTimes(dialog) {
    var timeInput = dialog.querySelector('[data-blog-call-time-input]');
    var timeButtons = Array.prototype.slice.call(dialog.querySelectorAll('[data-blog-call-time]'));
    if (!timeInput || !timeButtons.length) return;

    timeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        timeButtons.forEach(function (item) {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });

        button.classList.add('is-active');
        button.setAttribute('aria-pressed', 'true');
        timeInput.value = button.getAttribute('data-blog-call-time') || button.textContent.trim();
      });
    });

    var active = dialog.querySelector('[data-blog-call-time].is-active') || timeButtons[0];
    if (active) {
      active.classList.add('is-active');
      active.setAttribute('aria-pressed', 'true');
      timeInput.value = active.getAttribute('data-blog-call-time') || active.textContent.trim();
    }
  }

  function initDialog(dialog) {
    if (!dialog || dialog.dataset.blogCallReady === 'true') return;
    dialog.dataset.blogCallReady = 'true';

    initCalendar(dialog);
    initTimes(dialog);
    initPhoneCountry(dialog);
    ensureRecipientEmailPrefilled(dialog);

    dialog.querySelectorAll('[data-blog-call-modal-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        closeDialog(dialog);
      });
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) {
        closeDialog(dialog);
      }
    });

    var form = dialog.querySelector('[data-blog-call-form]');
    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }

        openMailto(dialog, buildMailto(dialog, form));
        showSuccess(dialog, form);
      });
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-blog-call-modal]').forEach(initDialog);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-blog-call-modal-open]');
    if (!trigger) return;

    var modalId = trigger.getAttribute('data-blog-call-modal-open');
    var dialog = modalId ? document.getElementById(modalId) : null;
    if (!dialog) return;

    event.preventDefault();
    initDialog(dialog);
    showForm(dialog);
    ensureRecipientEmailPrefilled(dialog);
    openDialog(dialog);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
